<template>
  <div>
    <p v-if="!hideText">Все файлы заявки</p>
    <button @click="openFilesModal" :class="{'btn btn-default': true, 'adjust_height': !hideText}" type="button">
      <i class="icon-fa icon-fa-file-image-o"/>
      <span v-if="!hideText">Показать файлы ({{ files.length }})</span>
    </button>
  </div>
</template>
<script>

export default {
  props: ['files', 'hideText'],
  data() {
    return {}
  },
  methods: {
    openFilesModal() {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'filesPreview', files: this.files}
      });
    },
  }
}

</script>

<style scoped>
button.adjust_height {
  height: 38px;
}
</style>
